/*
Password Reset Page (WhatsApp & E-mail)
---------------------------------------
Fluxo seguro, moderno e responsivo para redefinição de senha via WhatsApp e e-mail.
- 3 etapas: Solicitar código, Validar código, Nova senha.
- Limite de tentativas, expiração de código, feedback visual e mensagens claras.
- Backend e frontend integrados para máxima segurança e UX.
*/

import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import {
  TextField,
  Button,
  Snackbar,
  SnackbarContent,
  Typography,
  InputAdornment,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import api from "../../services/api";
// import logo from "../../assets/logologin.png";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import toastError from '../../errors/toastError';
import { toast } from "react-toastify";
import LockIcon from '@material-ui/icons/Lock';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EmailIcon from '@material-ui/icons/Email';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ReplayIcon from '@material-ui/icons/Replay';
// import { Toast } from "react-toastify/dist/components";

const useStyles = makeStyles((theme) => {
  const main = theme.palette.primary.main;
  const dark = theme.palette.primary.dark;
  return {
    '@global': {
      'body': {
        minHeight: '100vh',
        overflowY: 'auto !important',
        // Hide scrollbar for Webkit browsers (Chrome, Safari, Edge)
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        // Hide scrollbar for Firefox
        scrollbarWidth: 'none',
        // Hide scrollbar for IE and Edge (older versions)
        '-ms-overflow-style': 'none',
      },
    },
    root: {
      minHeight: "100vh",
      width: "100%", // Changed from 100vw to 100% for better compatibility
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start", // Changed from center to flex-start for page scroll
      background: `linear-gradient(135deg, ${main} 0%, ${dark} 100%)`,
      padding: 'clamp(16px, 4vw, 48px) 0', // Added dynamic padding like login page
      position: "relative",
      // overflowY: 'auto', // Removed from base to allow page scroll on desktop
      // height: '100vh', // Removed, minHeight is enough
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: { // For small screens (mobile)
        overflowY: 'auto', // Makes the root container itself scrollable
        // Hide scrollbar for Webkit browsers (Chrome, Safari, Edge)
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        // Hide scrollbar for Firefox
        scrollbarWidth: 'none',
        // Hide scrollbar for IE and Edge (older versions)
        '-ms-overflow-style': 'none',
      },
    },
    card: {
      backgroundColor: theme.mode === "light" ? "rgba(255,255,255,0.97)" : "rgba(20,20,20,0.97)",
      borderRadius: 22,
      boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
      padding: 0,
      minWidth: 320,
      maxWidth: 900, // ainda mais largo
      width: "100%", // ocupa toda a largura possível
      margin: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      [theme.breakpoints.down('xs')]: {
        minWidth: 0,
        maxWidth: '99vw',
        borderRadius: 0,
        width: '99vw',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 0,
        maxWidth: '99vw',
        borderRadius: 10,
        width: '99vw',
      },
      maxHeight: 'unset', // Remove restrição de altura
    },
    gridStep: {
      minWidth: 0,
      maxWidth: '100%',
      width: '100%',
      margin: 0,
      padding: 8,
      [theme.breakpoints.down('sm')]: {
        minWidth: 0,
        maxWidth: '100vw',
        padding: 0,
      },
    },
    fieldsRow: {
      display: 'flex',
      gap: 16,
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: 0,
      },
    },
    fieldHalf: {
      flex: 1,
      minWidth: 0,
    },
    buttonRow: {
      display: 'flex',
      gap: 12,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 16,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: 8,
        marginTop: 12,
      },
    },
    cardHeader: {
      textAlign: "center",
      padding: "38px 38px 0 38px",
      background: "none", // Remove fundo fixo, usa padrão do sistema
    },
    logoImg: {
      width: "100%",
      maxWidth: "100px",
      height: "auto",
      maxHeight: "100px",
      margin: "0 auto",
      // content: "url(/logo.png)", // Se quiser exibir logo
    },
    title: {
      fontWeight: 700,
      fontSize: 30,
      color: theme.palette.text.primary,
      marginBottom: 6,
      marginTop: 0,
    },
    subtitle: {
      fontSize: 16,
      color: theme.palette.text.secondary,
      marginBottom: 18,
      marginTop: 0,
    },
    cardContent: {
      padding: 28,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      background: "none",
    },
    form: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 18,
    },
    submit: {
      marginTop: 18,
      borderRadius: 10,
      fontWeight: 700,
      fontSize: 18,
      width: "100%",
      background: main,
      color: "#fff",
      padding: "14px 0",
      boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
      transition: "all 0.2s",
      '&:hover': {
        background: dark,
        transform: "scale(1.01)",
      },
    },
    cardFooter: {
      background: "none", // Remove fundo fixo, usa padrão do sistema
      borderTop: "none",
      padding: 18,
      textAlign: "center",
    },
    recoveryLink: {
      color: main,
      textDecoration: "underline",
      fontWeight: 500,
      cursor: "pointer",
      '&:hover': { color: dark },
    },
    bottomLink: {
      marginTop: 28,
      textAlign: "center",
      color: theme.palette.type === 'dark' || theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
      fontSize: 16,
      textShadow: "0 1px 4px rgba(0,0,0,0.10)",
      width: '100%',
      maxWidth: "100vw",
      marginLeft: "auto",
      marginRight: "auto",
      position: "static",
      left: "unset",
      top: "unset",
      transform: "none",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
    },
    loginButton: {
      width: '100%',
      maxWidth: 400,
      margin: '0 auto',
      background: theme.palette.primary.main,
      color: '#fff',
      fontWeight: 700,
      fontSize: 16,
      borderRadius: 10,
      boxShadow: '0 2px 8px 0 rgba(44,201,146,0.10)',
      padding: '12px 0',
      textTransform: 'none',
      transition: 'all 0.2s',
      '&:hover': {
        background: theme.palette.primary.dark,
        color: '#fff',
        transform: 'scale(1.01)',
      },
      marginTop: 8,
    },
    input: {
      background: theme.mode === "light" ? "rgba(255,255,255,0.7)" : "rgba(40,40,40,0.7)",
      borderRadius: 8,
    },
    label: {
      color: theme.palette.text.primary,
      fontWeight: 600,
      marginBottom: 4,
      fontSize: 15,
    },
  };
});

// ErrorBoundary para capturar erros de renderização do formulário
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error('Erro na tela de redefinição de senha:', error, errorInfo);
  }
  render() {
    const { primaryColor } = this.props;
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <Typography variant="h5" color="error">Ocorreu um erro inesperado.</Typography>
          <Typography variant="body1" style={{ marginTop: 12 }}>Tente recarregar a página ou voltar para o login.</Typography>
          <RouterLink to="/login" style={{ color: primaryColor || '#1976d2', fontWeight: 600, fontSize: 18, display: 'block', marginTop: 24 }}>Voltar para o login</RouterLink>
        </div>
      );
    }
    return this.props.children;
  }
}

const ResetPasswordPage = () => {

  const classes = useStyles();
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userId, setUserId] = useState(null);
  const [userFound, setUserFound] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showEmailInput, setShowEmailInput] = useState(true);
  const [verificationCode, setVerificationCode] = useState("");
  const [codeVerified, setCodeVerified] = useState(false);
  const [codeIncorrect, setCodeIncorrect] = useState(false);
  const [verificationAttempts, setVerificationAttempts] = useState(0);
  const [showVerifyButton, setShowVerifyButton] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({ email: "", password: "" });
  const [sendMethod, setSendMethod] = useState("whatsapp");
  const [whatsapp, setWhatsapp] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [passwordStrength, setPasswordStrength] = useState('');
  const [showPasswordTip, setShowPasswordTip] = useState(false);
  const prefersDark = theme.palette.type === 'dark' || theme.palette.mode === 'dark';

  const history = useHistory();

  const customSpacing = 16;

  const linkStyle = {
    textDecoration: "none", // Remover sublinhado do link
    color: "inherit", // Herdar a cor do texto original
    cursor: "pointer", // Adicionar cursor ao passar o mouse para indicar clicabilidade
  };

  // NOVO: Controle de etapas
  const [step, setStep] = useState(1); // 1: solicitar, 2: validar, 3: senha
  const [infoMessage, setInfoMessage] = useState("");

  // NOVO: Função para resetar tudo
  const resetAll = () => {
    setEmail("");
    setWhatsapp("");
    setConfirmEmail("");
    setVerificationCode("");
    setNewPassword("");
    setConfirmPassword("");
    setUserFound(false);
    setShowEmailInput(true);
    setCodeVerified(false);
    setShowVerifyButton(true);
    setShowSuccessMessage(false);
    setStep(1);
    setInfoMessage("");
  };

  // Atualiza handleSendCode para liberar passo 2 e bloquear passo 1
  const handleSendCode = async () => {
    console.log('handleSendCode chamado', { sendMethod, whatsapp, email }); // DEBUG
    try {
      if (sendMethod === "whatsapp") {
        if (!whatsapp || !email) {
          toastError("Preencha WhatsApp e e-mail corretamente.");
          return;
        }
        const response = await api.post("/enviar-whatsapp", { whatsapp, email });
        console.log('Resposta do backend (whatsapp):', response); // DEBUG
        setShowEmailInput(false);
        setStep(2);
        setInfoMessage("Se os dados estiverem corretos, você receberá um código no WhatsApp cadastrado.");
        if (response.data && response.data.success) {
          setUserFound(true);
        } else if (response.data && response.data.error) {
          toastError(response.data.error);
          setUserFound(false);
        } else {
          setUserFound(false);
        }
      } else if (sendMethod === "email") {
        if (!email) {
          toastError("Preencha o e-mail corretamente.");
          return;
        }
        // Avança para etapa 2 e mostra mensagem lá
        setShowEmailInput(false);
        setStep(2);
        setInfoMessage("Se o e-mail estiver correto, você receberá um código.");
      }
    } catch (error) {
      console.error('Erro ao enviar código:', error); // DEBUG
      setUserFound(false);
      setShowEmailInput(false);
      setStep(2);
      if (error?.response?.data?.error) {
        toastError(error.response.data.error);
      } else {
        toastError("Erro ao enviar código. Aguarde alguns minutos e tente novamente.");
      }
      setInfoMessage("");
    }
  };

  const handleVerifyCode = async () => {
    try {
      if (!confirmEmail) {
        toastError("Confirme o e-mail cadastrado.");
        return;
      }
      const response = await api.get(`/verificar-code/${whatsapp}`, {
        params: { code: verificationCode, email: confirmEmail }
      });
      if (response.data && response.data.success) {
        setCodeVerified(true);
        setShowVerifyButton(false);
        setShowSuccessMessage(true);
        setStep(3);
      } else if (response.data && response.data.error) {
        toastError(response.data.error);
        setCodeIncorrect(true);
        setVerificationAttempts(verificationAttempts + 1);
      } else {
        toastError("Código inválido ou expirado. Solicite um novo código.");
        setCodeIncorrect(true);
        setVerificationAttempts(verificationAttempts + 1);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError(error.response.data.error);
      } else {
        toastError("Erro ao verificar código. Tente novamente.");
      }
    }
    if (codeIncorrect) {
      toastError("Código incorreto. Tente novamente.");
      if (verificationAttempts >= 2) {
        toastError("Tentativas excedidas. Aguarde alguns minutos ou solicite novo código.");
        setTimeout(() => {
          history.push("/login");
        }, 3000);
      }
      setCodeIncorrect(false);
    }
  };

  const handleResetCode = () => {
    setCodeIncorrect(false);
    setVerificationCode("");
  };

  const handleSavePassword = async () => {
    // Validação de requisitos mínimos
    const passwordRequirements = [
      newPassword.length >= 8,
      /[a-z]/.test(newPassword),
      /[A-Z]/.test(newPassword),
      /[0-9]/.test(newPassword)
    ];
    if (!passwordRequirements.every(Boolean)) {
      toastError("A senha deve ter pelo menos 8 caracteres, conter letras maiúsculas, minúsculas e números.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toastError("As senhas não coincidem.");
      return;
    }
    if (!confirmEmail) {
      toastError("Confirme o e-mail cadastrado.");
      return;
    }
    if (userFound && codeVerified) {
      try {
        await api.put("/atualizar-senha", { whatsapp, email: confirmEmail, newPassword });
        toast.success("Senha atualizada com sucesso! Faça login com sua nova senha.");
        setTimeout(() => {
          history.push("/login");
        }, 1000);
      } catch (err) {
        if (err?.response?.data?.error) {
          toastError(err.response.data.error);
        } else {
          toastError("Erro ao salvar senha. Tente novamente.");
        }
      }
    } else {
      toastError("Usuário não encontrado ou código inválido.");
    }
  };

  const handleCloseSnackbar = () => {
    // setOpenSnackbar(false);
  };

  // Barra de progresso/steps visual
  const steps = [
    { label: 'Solicitar código', icon: <EmailIcon style={{ color: step >= 1 ? theme.palette.primary.main : '#bbb' }} /> },
    { label: 'Validar código', icon: <LockIcon style={{ color: step >= 2 ? theme.palette.primary.main : '#bbb' }} /> },
    { label: 'Nova senha', icon: <CheckCircleIcon style={{ color: step === 3 ? theme.palette.primary.main : '#bbb' }} /> },
  ];

  // Validação instantânea dos campos
  const validateWhatsapp = (value) => /^\d{10,15}$/.test(value);
  const validateEmail = (value) => /.+@.+\..+/.test(value);
  const validateCode = (value) => /^\d{4,8}$/.test(value);
  // Função pura para validação de senha
  const validatePassword = (value) => {
    if (value.length < 8) return 'fraca';
    if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value)) return 'média';
    return 'forte';
  };
  // Atualiza força da senha sempre que newPassword mudar
  React.useEffect(() => {
    setPasswordStrength(validatePassword(newPassword));
  }, [newPassword]);

  // Timer para reenviar código
  React.useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleResendCode = async () => {
    setResendTimer(30);
    await handleSendCode();
  };

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <ErrorBoundary primaryColor={theme.palette.primary.main}>
          {/* Barra de progresso/steps visual */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 24, padding: 24, background: 'none', borderBottom: '1px solid #eee' }}>
            {steps.map((s, idx) => (
              <div key={s.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', opacity: step >= idx + 1 ? 1 : 0.5 }}>
                {s.icon}
                <span style={{ fontSize: 13, marginTop: 4, color: prefersDark ? '#fff' : '#222' }}>{s.label}</span>
                {idx < steps.length - 1 && <div style={{ width: 40, height: 2, background: step > idx + 1 ? theme.palette.primary.main : '#bbb', margin: '8px 0' }} />}
              </div>
            ))}
          </div>
          <div className={classes.cardHeader}>
            {/* Ícone ilustrativo da etapa */}
            <div style={{ fontSize: 40, marginBottom: 8 }}>
              {step === 1 && (sendMethod === 'whatsapp' ? <WhatsAppIcon fontSize="inherit" style={{ color: theme.palette.primary.main }} /> : <EmailIcon fontSize="inherit" style={{ color: theme.palette.primary.main }} />)}
              {step === 2 && <LockIcon fontSize="inherit" style={{ color: theme.palette.primary.main }} />}
              {step === 3 && <CheckCircleIcon fontSize="inherit" style={{ color: theme.palette.primary.main }} />}
            </div>
            <div className={classes.title} style={{ color: theme.palette.text.primary }}>
              {sendMethod === "whatsapp"
                ? "Redefinir senha via WhatsApp"
                : "Redefinir senha"}
            </div>
            <div className={classes.subtitle} style={{ color: theme.palette.text.secondary }}>
              Informe seu e-mail ou WhatsApp cadastrado para receber o código de verificação.
            </div>
          </div>
          <div className={classes.cardContent}>
            <form className={classes.form} autoComplete="off">
              <Grid container spacing={3} justifyContent="center" alignItems="flex-start" style={{ width: '100%', margin: 0 }}>
                {/* Etapa 1: Solicitar código */}
                <Grid item xs={12} className={classes.gridStep} style={{ display: step === 1 ? 'block' : 'none', width: '100%', maxWidth: '100%' }}>
                  <Typography variant="h6" style={{ marginBottom: 8, color: prefersDark ? '#fff' : undefined }}>1. Solicite o código</Typography>
                  <Typography variant="body2" style={{ marginBottom: 8, color: '#888' }}>
                    Informe seu e-mail e WhatsApp cadastrados. Você receberá um código de verificação para redefinir sua senha.
                  </Typography>
                  <FormControl component="fieldset" style={{ marginBottom: 16 }}>
                    <FormLabel component="legend" style={{ color: prefersDark ? '#fff' : undefined }}>Como deseja receber o código?</FormLabel>
                    <RadioGroup row value={sendMethod} onChange={e => setSendMethod(e.target.value)}>
                      <FormControlLabel value="email" control={<Radio color="primary" size="small" />} label={<span style={{ color: prefersDark ? '#fff' : undefined }}>E-mail</span>} />
                      <FormControlLabel value="whatsapp" control={<Radio color="primary" size="small" />} label={<span style={{ color: prefersDark ? '#fff' : undefined }}>WhatsApp</span>} />
                    </RadioGroup>
                  </FormControl>
                  <div className={classes.fieldsRow}>
                    <TextField
                      className={classes.fieldHalf}
                      required
                      type="text"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="WhatsApp cadastrado"
                      placeholder="Digite seu número com DDD"
                      onChange={(e) => setWhatsapp(e.target.value)}
                      value={whatsapp}
                      InputProps={{ className: classes.input }}
                      size="small"
                      error={!!whatsapp && !validateWhatsapp(whatsapp)}
                      helperText={whatsapp && !validateWhatsapp(whatsapp) ? 'Número inválido. Ex: 11999999999' : ''}
                      style={{ marginBottom: 0 }}
                    />
                    <TextField
                      className={classes.fieldHalf}
                      required
                      type="email"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="E-mail cadastrado"
                      placeholder="Digite seu e-mail cadastrado"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      InputProps={{ className: classes.input }}
                      size="small"
                      error={!!email && !validateEmail(email)}
                      helperText={email && !validateEmail(email) ? 'E-mail inválido' : ''}
                      style={{ marginBottom: 0 }}
                    />
                  </div>
                  <div className={classes.buttonRow}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSendCode}
                      className={classes.submit}
                      style={{ fontSize: 14, padding: '8px 0', minHeight: 36, maxWidth: 180, alignSelf: 'center' }}
                      size="small"
                      disabled={sendMethod === 'whatsapp' ? !validateWhatsapp(whatsapp) || !validateEmail(email) : !validateEmail(email)}
                    >
                      Enviar código de verificação
                    </Button>
                  </div>
                </Grid>

                {/* Etapa 2: Validar código */}
                <Grid item xs={12} md={4} className={classes.gridStep} style={{ display: step === 2 ? 'block' : 'none', width: '100%', maxWidth: '100%' }}>
                  <Typography variant="h6" style={{ marginBottom: 8, color: prefersDark ? '#fff' : undefined }}>2. Valide o código</Typography>
                  <Typography variant="body2" style={{ marginBottom: 8, color: '#888' }}>
                    Digite o código recebido e confirme seu e-mail cadastrado.
                  </Typography>
                  <TextField
                    label="Código de verificação"
                    type="text"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={e => setVerificationCode(e.target.value)}
                    value={verificationCode}
                    InputProps={{ className: classes.input }}
                    required
                    style={{ marginTop: customSpacing }}
                    size="small"
                    disabled={step !== 2}
                    error={!!verificationCode && !validateCode(verificationCode)}
                    helperText={verificationCode && !validateCode(verificationCode) ? 'Código inválido' : ''}
                  />
                  <TextField
                    label="E-mail cadastrado"
                    type="email"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={e => setConfirmEmail(e.target.value)}
                    value={confirmEmail}
                    InputProps={{ className: classes.input }}
                    required
                    style={{ marginTop: customSpacing }}
                    size="small"
                    disabled={step !== 2}
                    error={!!confirmEmail && !validateEmail(confirmEmail)}
                    helperText={confirmEmail && !validateEmail(confirmEmail) ? 'E-mail inválido' : ''}
                  />
                  {showVerifyButton && (
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleVerifyCode}
                      style={{ marginTop: customSpacing, fontSize: 14, padding: '8px 0', minHeight: 36, maxWidth: 180, alignSelf: 'center' }}
                      size="small"
                      disabled={step !== 2}
                    >
                      Verificar código
                    </Button>
                  )}
                  {/* Botão de reenviar código movido para etapa 2 */}
                  <div className={classes.buttonRow}>
                    {resendTimer > 0 ? (
                      <Button
                        startIcon={<ReplayIcon />}
                        disabled
                        style={{ color: '#888' }}
                        size="small"
                      >
                        Reenviar em {resendTimer}s
                      </Button>
                    ) : (
                      <Button
                        startIcon={<ReplayIcon />}
                        onClick={async () => {
                          // Use confirmEmail se válido, senão email da etapa 1
                          const emailToUse = validateEmail(confirmEmail) ? confirmEmail : email;
                          if (validateWhatsapp(whatsapp) && validateEmail(emailToUse)) {
                            setResendTimer(30);
                            // Chama a API diretamente para evitar reset de step
                            try {
                              let response;
                              if (sendMethod === "whatsapp") {
                                response = await api.post("/enviar-whatsapp", { whatsapp, email: emailToUse });
                              } else {
                                response = await api.post("/enviar-email", { email: emailToUse });
                              }
                              if (response.data && response.data.success) {
                                toast.success("Novo código enviado!");
                              } else if (response.data && response.data.error) {
                                toastError(response.data.error);
                              } else {
                                toastError("Não foi possível reenviar o código.");
                              }
                            } catch (err) {
                              toastError("Erro ao reenviar código. Tente novamente.");
                            }
                          } else {
                            toastError('Preencha WhatsApp e e-mail válidos para reenviar.');
                          }
                        }}
                        style={{ color: theme.palette.primary.main }}
                        size="small"
                      >
                        Reenviar código
                      </Button>
                    )}
                  </div>
                  {showSuccessMessage && (
                    <Typography
                      variant="body1"
                      style={{ color: theme.palette.success ? theme.palette.success.main : theme.palette.primary.main, marginTop: customSpacing }}
                    >
                      Código validado com sucesso.
                    </Typography>
                  )}
                  {infoMessage && (
                    <Typography variant="body2" style={{ color: '#666', marginTop: 12, textAlign: 'center' }}>{infoMessage}</Typography>
                  )}
                </Grid>

                {/* Etapa 3: Nova senha */}
                <Grid item xs={12} md={4} className={classes.gridStep} style={{ display: step === 3 ? 'block' : 'none', width: '100%', maxWidth: '100%' }}>
                  <Typography variant="h6" style={{ marginBottom: 8, color: prefersDark ? '#fff' : undefined }}>3. Defina a nova senha</Typography>
                  <Typography variant="body2" style={{ marginBottom: 8, color: '#888' }}>
                    Crie uma senha forte para proteger sua conta.
                  </Typography>
                  <TextField
                    label="Nova Senha"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={(e) => { setNewPassword(e.target.value); setShowPasswordTip(true); }}
                    value={newPassword}
                    style={{ marginTop: customSpacing }}
                    InputProps={{
                      className: classes.input,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            size="small"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                    disabled={step !== 3}
                    error={!!newPassword && passwordStrength !== 'forte'}
                    helperText={showPasswordTip && (
                      <span>
                        <span style={{ color:
                          passwordStrength === 'forte'
                            ? (theme.palette.success ? theme.palette.success.main : theme.palette.primary.main)
                            : passwordStrength === 'média'
                              ? (theme.palette.warning ? theme.palette.warning.main : theme.palette.primary.main)
                              : (theme.palette.error ? theme.palette.error.main : theme.palette.primary.main)
                        }}>
                          {passwordStrength === 'forte' && 'Senha forte'}
                          {passwordStrength === 'média' && 'Senha média: use letras maiúsculas, minúsculas e números'}
                          {passwordStrength === 'fraca' && 'Senha fraca: mínimo 8 caracteres'}
                        </span>
                      </span>
                    )}
                  />
                  <TextField
                    label="Confirme a Nova Senha"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    value={confirmPassword}
                    style={{ marginTop: customSpacing }}
                    InputProps={{
                      className: classes.input,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            size="small"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                    disabled={step !== 3}
                    error={!!confirmPassword && newPassword !== confirmPassword}
                    helperText={!!confirmPassword && newPassword !== confirmPassword ? 'As senhas não coincidem' : ''}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSavePassword}
                    style={{ marginTop: customSpacing, fontSize: 14, padding: '8px 0', minHeight: 36, maxWidth: 180, alignSelf: 'center' }}
                    className={classes.submit}
                    size="small"
                    disabled={step !== 3}
                  >
                    Salvar Senha
                  </Button>
                </Grid>
              </Grid>
              <Grid container justifyContent="center" style={{ marginTop: 24, width: '100%' }}>
                <Grid item xs={12} className={classes.bottomLink} style={{ width: '100%' }}>
                  <RouterLink to="/login" style={{ textDecoration: 'none', width: '100%' }}>
                    <Button className={classes.loginButton} fullWidth>
                      Voltar para o login
                    </Button>
                  </RouterLink>
                </Grid>
              </Grid>
            </form>
          </div>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
